module.exports = __webpack_public_path__ + "img/组 5.81edfa59.png";